import { getLang as documentUtilsGetLang } from '@utils/documentUtils';
import { dateConstants } from '@utils/constants';
import { dateUtils } from '@utils';

export default function dateShortFormat(value, language = documentUtilsGetLang()) {
    if (Object.prototype.toString.call(value) === '[object Date]') {
        return dateUtils.format(value, dateConstants.FORMAT.DATE_SHORT, language);
    }

    return dateUtils.format(
        dateUtils.parseString(value),
        dateConstants.FORMAT.DATE_SHORT,
        language
    );
}
